import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import { useScopeStore } from '../../../shared/scope/useCurrentScope.js';
import {
  getWorkspaceSettings,
  getWorkspaceSettingsQueryKey,
  patchWorkspaceSettings,
  type UpdateWorkspaceSettingsInput,
  type WorkspaceSettingsResponse,
} from '../api/settings.client.js';

export function useWorkspaceSettings() {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getWorkspaceSettingsQueryKey(workspaceId),
    queryFn: () => getWorkspaceSettings(),
    enabled: scope !== null,
  });
}

export function useUpdateWorkspaceSettingsMutation() {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  const queryClient = useQueryClient();

  return useMutation<WorkspaceSettingsResponse, Error, UpdateWorkspaceSettingsInput>({
    mutationFn: (input) => patchWorkspaceSettings(input),
    onSuccess: async (data) => {
      useScopeStore.setState({ workspaceSettings: data });
      queryClient.setQueryData(getWorkspaceSettingsQueryKey(workspaceId), data);
      await queryClient.invalidateQueries({ queryKey: getWorkspaceSettingsQueryKey(workspaceId) });
    },
  });
}
